import { css } from "@emotion/react";

export const wrapper = css`
  text-align: center;
`;

export const input = css`
  margin-bottom: 1rem;

  :not(:last-of-type) {
    margin-top: 0.5rem;
  }
`;
